import { Box } from '@mui/material'
import { Clock20Regular, Flash20Regular } from '@/components/Icon'
import HomeNavPulseRow from './HomeNavPulseRow'
import styles from './HomeNavPane.module.scss'

export default function HomeNavAutomationRows(props) {
  return (
    <Box className={styles.group}>
      <HomeNavPulseRow
        Icon={Flash20Regular}
        label="Triggers"
        active={Boolean(props.triggersActive)}
        onClick={props.onTriggers}
      />
      <HomeNavPulseRow
        Icon={Clock20Regular}
        label="Schedules"
        active={Boolean(props.schedulesActive)}
        onClick={props.onSchedules}
      />
    </Box>
  )
}
